"use strict";
import React from "react";
import { RX } from './constants';

const initComponent = (flex = window.flex) => {

    class OAuthCallback extends React.Component {
        componentDidMount() {
            flex.trigger(RX.RUN_CALLBACK_FLOW);
        }

        render() {
            const styles = {
                height: 100
            };

            return (
                <div className="oauth-callback" ref={element => this.element = element} style={styles}>
                    <div className="oauth-callback__message">
                        Wait. Authentication is going on.
                </div>
                </div>
            );
        }
    }

    return OAuthCallback;
}

export default initComponent;